import { LocaleDetails } from 'shared/src/types/languages.type';

export function updateUrlWithQuery(searchQuery: string, locale: LocaleDetails) {
  const url = new URL(window.location.href);

  // Keep Next's history.state intact. Passing `null` wipes the App Router
  // marker and can make a `?q=` write look like a navigation — which remounts
  // the search bar and races the in-flight shelf fetch.
  const nextState = window.history.state;

  // If there's already a `q` param, replace it
  if (url.searchParams.has('q')) {
    url.searchParams.set('q', searchQuery);
    window.history.replaceState(nextState, '', url.toString());
  } else {
    url.pathname = url.pathname.replace(/\/$/, '');
    url.searchParams.set('q', searchQuery);
    window.history.pushState(nextState, '', url.toString());
  }
}

// import { useCallback } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// export function useUpdateQuery(searchQuery, locale) {
//   const navigate = useNavigate();
//   const location = useLocation();

//   return useCallback(() => {
//     const params = new URLSearchParams(location.search);

//     // If `q` exists, we'll replace; otherwise we'll push a new entry
//     const shouldReplace = params.has('q');
//     params.set('q', searchQuery);

//     const base = location.pathname.replace(/\/$/, '');
//     const newPath = shouldReplace
//       ? base // keep the same path if locale already applied
//       : `${base}/${locale.path}`;

//     navigate(
//       {
//         pathname: newPath,
//         search: `?${params.toString()}`,
//       },
//       { replace: shouldReplace },
//     );
//   }, [navigate, location, searchQuery, locale.path]);
// }
